module.exports = __webpack_public_path__ + "img/logo_horizontal.001fb650.svg";